import React, { useState } from "react";
import PropTypes from "prop-types";

import { Form, FormGroup, Row, Col, Input, Button } from "../../simple";

const XandrForm = ({ handleSubmit, handleZIP, className, error }) => {
  const [state, setState] = useState({
    username: "",
    password: ""
  });
  const { username, password } = state;

  const handleInput = (name, value) => {
    setState({ ...state, [name]: value });
  };

  const onSubmit = e => {
    e.preventDefault();
    handleSubmit(state);
  };

  return (
    <Form onSubmit={onSubmit} className={`invite-form ${className}`}>
      <h2 className="title">Sign in to xandr</h2>
      <FormGroup>
        <Row>
          <Col lg={12} md={12} sm={12}>
            <Input
              type="text"
              value={username}
              label="Xandr username"
              name="username"
              placeholder="Xandr username"
              required
              handleChange={handleInput}
            />
          </Col>
          <Col lg={12} md={12} sm={12}>
            <Input
              type="password"
              value={password}
              label="Password"
              name="password"
              placeholder="Password"
              required
              handleChange={handleInput}
            />
          </Col>
        </Row>
        <Row>
          <Col>{error && <small className="text-danger">{error}</small>}</Col>
        </Row>
      </FormGroup>
      <Button
        type="submit"
        className="button"
        style={{ minWidth: "133px", justifyContent: "center" }}
      >
        Sign in
      </Button>
      {error && (
        <div className="mt-5">
          <small className="text-info">or you may to</small>
          <Button
            type="button"
            className="button"
            onClick={handleZIP}
            style={{ minWidth: "133px", justifyContent: "center" }}
          >
            Dowload file
          </Button>
        </div>
      )}
    </Form>
  );
};

XandrForm.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  handleSubmit: PropTypes.func,
  handleZIP: PropTypes.func
};

XandrForm.defaultProps = {
  className: "",
  error: "",
  handleSubmit: () => {},
  handleZIP: () => {}
};

export default XandrForm;
